import { render, staticRenderFns } from "./ClientAppOrders.vue?vue&type=template&id=2985f35a&scoped=true&"
import script from "./ClientAppOrders.vue?vue&type=script&lang=js&"
export * from "./ClientAppOrders.vue?vue&type=script&lang=js&"
import style0 from "./ClientAppOrders.vue?vue&type=style&index=0&id=2985f35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985f35a",
  null
  
)

export default component.exports